/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type RoadBlockageCreationVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  latestLocation: {
    __typename?: 'VehicleLocation'
    heading: number | null
    location: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    } | null
  } | null
}

export const RoadBlockageCreationVehicleFragmentDoc = gql`
    fragment RoadBlockageCreationVehicle on Vehicle {
  id
  latestLocation {
    location {
      latitude
      longitude
    }
    heading
  }
}
    `
